import { useContext, useMemo } from 'react'

import { SanityBlogPostWithoutBody } from '@data/sanity/queries/types/blog'
import { getFilteredHeroModules, getFilteredPageModules } from '@lib/module'
import { PageHeroContext } from '@lib/page-hero-context'
import { PageModuleContext } from '@lib/page-module-context'

import Module from './module'

export interface ModulesProps {
  posts?: SanityBlogPostWithoutBody[]
}

const Modules = ({ posts }: ModulesProps) => {
  const { heroModule } = useContext(PageHeroContext)
  const { pageModules, casePageModules, previewPageModules } =
    useContext(PageModuleContext)

  const activeHeroModule = useMemo(() => {
    if (previewPageModules) {
      return getFilteredHeroModules(previewPageModules)[0]
    }

    return heroModule
  }, [heroModule, previewPageModules])

  const activePageModules = useMemo(() => {
    if (previewPageModules) {
      return getFilteredPageModules(previewPageModules)
    }

    return casePageModules ?? pageModules
  }, [casePageModules, pageModules, previewPageModules])

  if (!activeHeroModule && activePageModules.length === 0) {
    return null
  }

  return (
    <>
      {!!activeHeroModule && <Module module={activeHeroModule} />}
      {activePageModules.map((module) => (
        <Module key={module._key} module={module} posts={posts} />
      ))}
    </>
  )
}

export default Modules
